import { customFetch } from "@/client/custom-fetch";

import {
  TAiModel,
  TAiProvider,
  TCreateUserInput,
  TUpdateUserInput,
  TUser,
} from "./users.types";

const API_BASE = "/users";

export const getAllUsers = async (): Promise<TUser[]> => {
  return customFetch<TUser[]>(`${API_BASE}`);
};

export const geTUserById = async (clientId: string): Promise<TUser> => {
  return customFetch<TUser>(`${API_BASE}/${clientId}`);
};

export const createUser = async (
  data: TCreateUserInput
): Promise<TUser & { refreshToken: string }> => {
  return customFetch<TUser & { refreshToken: string }>(`${API_BASE}`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateUser = async (
  clientId: string,
  data: TUpdateUserInput
): Promise<TUser> => {
  return customFetch<TUser>(`${API_BASE}/${clientId}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
};

export const deleteUser = async (clientId: string): Promise<void> => {
  return customFetch<void>(`${API_BASE}/${clientId}`, {
    method: "DELETE",
  });
};

export const getAllAiProviders = async (): Promise<TAiProvider[]> => {
  return customFetch<TAiProvider[]>("/ai-provider");
};

export const getAIModelByProvider = async (
  providerId: string
): Promise<TAiModel[]> => {
  return customFetch<TAiModel[]>(`/ai-model/provider/${providerId}`);
};

export const uploadKnowledgeBase = async (
  clientId: string,
  name: string,
  files: File[]
): Promise<void> => {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("clientId", clientId);

  files.forEach((file) => {
    formData.append("files", file);
  });

  return customFetch<void>("/api/knowledge-base", {
    method: "POST",
    body: formData,
  });
};
